import React, { useEffect, useState, Fragment } from 'react';
import DashboardHeader from '../Common/DashboardHeader';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { AcceptedData, AcceptedDataApi, CreateCustomerApi, ExportDataApi, MailSentApi, PendingData, PendingDataApi, ResendEmailApi, UpdateHDFCRMApi, UpdatePhoneEmailApi, UpdateV2PRMApi, getPartnerBank, getPartnerData, refreshTokenCall, v2pRMApi } from '../../services/redux/ApiActions';
import { setPendingData } from '../../services/redux/PendingReducer';
import { setAcceptedData } from '../../services/redux/AcceptedReducer';
import { setMailSentData } from '../../services/redux/MailSentReducer';
import { setFiltersData } from '../../services/redux/FilterReducer';
import Select from 'react-select';
import Bowser from 'bowser';
import showNotification from '../../services/redux/NotifcationService';

import { Authenticate } from '../../services/redux/AuthenticationReducer';
import { LoginUser } from '../../services/redux/LoginReducer';
import CustomerInput from '../reusableComponents/CustomerInput';
import FilterEmailInput from '../reusableComponents/FilterEmailInput';
import FilterPhoneInput from '../reusableComponents/FilterPhoneInput';
import { Dialog, Disclosure, Popover, Tab, Transition } from '@headlessui/react'
import OnboardingCustomerInput from '../reusableComponents/OnboardingCustomerInput';
import OnboardingEmailInput from '../reusableComponents/OnboardingEmailInput';
import OnboardingPhoneInput from '../reusableComponents/OnboardingPhoneInput';
import OnboardingHDFCRMInput from '../reusableComponents/OnboardingHDFCRMInput';
import { setV2PRMData } from '../../services/redux/V2PRMReducer';
import LogoDiv from '../Common/LogoDiv';
import ToolTipComponent from '../Common/ToolTipComponent';
import StaffFilters from "../Common/StaffFilters.js";
import StaffGrid from "../Common/StaffGrid.js";
import StaffPagination from "../Common/StaffPagination.js";
import { emailRegex } from '../Common/EmailRegex.js';
import logo from '../../img/BBPS_Horizontal.png';

const MailSent = () => {
  const mailSentData = useSelector((state) => state.mailSent.MailSentData);
  const pendingData = useSelector((state) => state.pending.PendingData);
  const acceptedData = useSelector((state) => state.accepted.AcceptedData);
  const loginData = useSelector((state) => state.login.loginData);
  const savedfilterData = useSelector((state) => state.filterData.FiltersData);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(100);
  const [pendingCurrentPage, setPendingCurrentPage] = useState(1);
  const [pendingPageSize, setPendingPageSize] = useState(100);
  const [acceptedCurrentPage, setAcceptedCurrentPage] = useState(1);
  const [acceptedPageSize, setAcceptedPageSize] = useState(100);
  const [totalPages, setTotalPages] = useState(1);
  const [totalPendingPages, setTotalPendingPages] = useState(1);
  const [totalAcceptedPages, setTotalAcceptedPages] = useState(1);

  const [displayedData, setDisplayedData] = useState([]);
  const [displayedData1, setDisplayedData1] = useState([]);
  const [displayedData2, setDisplayedData2] = useState([]);

  const [selectedItem, setSelectedItem] = useState(null);
  const [changeEmail, setChangeEmail] = useState('');
  const [changePhone, setChangePhone] = useState('');
  const [filterCustomerName, setFilterCustomerName] = useState('');
  const [filterCustomerPhone, setFilterCustomerPhone] = useState('');
  const [filterCustomerEmail, setFilterCustomerEmail] = useState('');
  const [v2pRM, setV2pRm] = useState()
  const [partnerBank, setPartnerBank] = useState()
  const [program, setProgram] = useState()
  const [selectedPrograms, setSelectedPrograms] = useState()
  const [selectedValue, setSelectedValue] = useState('');
  const [selectedValueID, setSelectedValueID] = useState(1);
  const [selectedBank, setSelectedBank] = useState('');
  const [selectedBankID, setSelectedBankID] = useState();
  const [customerId, setCustomerId] = useState(0);
  const [hdfcRM, setHDFCRM] = useState('');
  const [OBCustomerName, setOBCustomerName] = useState('');
  const [OBCustomerEmail, setOBCustomerEmail] = useState('');
  const [OBCustomerPhone, setOBCustomerPhone] = useState('');
  const [OBCustomerHDFCRM, setOBCustomerHDFCRM] = useState();
  const [customerName, setCustomerName] = useState('');

  const userAgent = window.navigator.userAgent;
  const parsedInfo = Bowser.parse(userAgent);
  // Handle change event
  const handleChangeProgram = (selectedOptions) => {
    setSelectedPrograms(selectedOptions);
    // console.log(selectedOptions)
  };
const handleChangeOBCustomerName = (event) => {
  const input = event.target.value;

  if (input.length <= 50) {
    setOBCustomerName(input);
  }
};
  const handleOBCustomerEmail = (e) => {
    const input = e.target.value;
  const emailCharRegex = /^[a-zA-Z0-9@._-]*$/;

  // Allow input only if it matches allowed pattern (partial email)
  if (input === "" || emailCharRegex.test(input)) {
    setOBCustomerEmail(input);
  }
  };

  const handleOBCustomerPhone = (event) => {
    // Update the state with the selected value
    const value = event.target.value.slice(0, 10)
    const sanitizedValue = value.replace(/\D/g, '');
    setOBCustomerPhone(sanitizedValue);
  };

  const handleOBCustomerHDFCRM = (event) => {
    // Update the state with the selected value
    setOBCustomerHDFCRM(event.target.value);
  };
  const handleChange = (event) => {
    // Update the state with the selected value
    setSelectedValue(event.target.value);
    const selectedId = event.target.options[event.target.selectedIndex].getAttribute('data-id');

    // console.log(selectedId)
  };
  const handleChangeV2PRM = (event) => {
    // Update the state with the selected value
    setSelectedValue(event.target.value);
    const selectedId = event.target.options[event.target.selectedIndex].getAttribute('data-id');
    UpdateV2PRM(customerId, selectedId)
  };
  const handleHDFCRMChange = (e) => {
    setHDFCRM(e.target.value);
  };
  const handleChangeBank = (event) => {
    // Update the state with the selected value
    console.log(event)
    if (event) {
      // Update the state with the selected value and id
      setSelectedBankID(event.value);
      setSelectedBank(event);
    }
    // const selectedId = event.target.options[event.target.selectedIndex].getAttribute('data-id');
    // setSelectedBankID(selectedId)
    // setSelectedBank(event.target.value);
    // console.log(selectedId)
  };
  const openEditModal = (item) => {
    setIsProfileModalOpen(true);
    setSelectedItem(item);
    // console.log(item)
    setCustomerId(item.id)
    setCustomerName(item?.customerName || '');
    setChangeEmail(item?.email || '');
    setChangePhone(item?.phone || '');
  };

  const openEditV2PRMModal = (item) => {
    const selected = v2pRM?.find(data => data?.id === item.v2PRM);
    setIsRMModalOpen(true);
    setSelectedValue(selected.email);
    setCustomerName(item.customerName)
    setCustomerId(item.id);
    setHDFCRM(item.hdfcrm);
    // console.log(item);
  };

  const handleEmailChange = (e) => {
    setChangeEmail(e.target.value);
  };

  const handlePhoneChange = (e) => {
    setChangePhone(e.target.value);
  };


  const handlePageClick = (page) => {
    // Update the current page and fetch data for the new page
    setCurrentPage(page);
    mailSentCall(page, pageSize);
  };
  const handlePendingPageClick = (page) => {
    // Update the current page and fetch data for the new page
    setPendingCurrentPage(page);
    PendingAPICall(page, pendingPageSize);
  };
  const handlePendingNextClick = () => {
    // Check if the next button is disabled before proceeding
    if (pendingCurrentPage < totalPendingPages) {
      handlePendingPageClick(pendingCurrentPage + 1);
    }
  };
  const handleAcceptedPageClick = (page) => {
    // Update the current page and fetch data for the new page
    setAcceptedCurrentPage(page);
    AcceptedAPICall(page, acceptedPageSize);
  };
  const handleAcceptedNextClick = () => {
    // Check if the next button is disabled before proceeding
    if (acceptedCurrentPage < totalAcceptedPages) {
      handleAcceptedPageClick(acceptedCurrentPage + 1);
    }
  };
  const handleNextClick = () => {
    // Check if the next button is disabled before proceeding
    if (currentPage < totalPages) {
      handlePageClick(currentPage + 1);
    }
  };
  const handleChangeNameFilter = (e) => {
    setFilterCustomerName(e.target.value)
  };

  const handleChangePhoneFilter = (e) => {
    const value = e.target.value.slice(0, 10)
    const sanitizedValue = value.replace(/\D/g, '');
    setFilterCustomerPhone(sanitizedValue);
  };
  const handleChangeEmailFilter = (e) => {
    setFilterCustomerEmail(e.target.value)
  };
  const getStartingSerialNumber = () => {
    // Calculate the starting serial number for the current page
    return (currentPage - 1) * pageSize + 1;
  };
  const navigate = useNavigate();

  useEffect(() => {
    // console.log('mailSent', loginData)
    mailSentCall(currentPage, pageSize);
    v2pRM_API_CALL();
    partnerBank_Api_Call();
    program_Api_Call();
  }, [pageSize])
  const getPageNumbers = () => {
    const pageNumbers = [];
    for (let i = 1; i <= totalPages; i++) {
      pageNumbers.push(
        <li
          key={i} className={currentPage === i ? 'active' : ''}>
          <button
            className={`px-4 py-2 rounded-md hover:bg-gray-50`}
            style={{
              backgroundColor: currentPage === i ? 'blue' : '',
              color: currentPage === i ? 'white' : 'black'
            }}
            rel="customerList"
            onClick={() => handlePageClick(i)}
          >
            {i}
          </button>
        </li >
      );
    }
    return pageNumbers;
  };
  const getPendingPageNumbers = () => {
    const pageNumbers = [];
    for (let i = 1; i <= totalPendingPages; i++) {
      pageNumbers.push(
        <li key={i} className={pendingCurrentPage === i ? 'active' : ''}>
          <button
            rel="customerList"
            className={`px-4 py-2 rounded-md hover:bg-gray-50`}
            style={{
              backgroundColor: currentPage === i ? 'blue' : '',
              color: currentPage === i ? 'white' : 'black'
            }}
            onClick={() => handlePendingPageClick(i)}
          >
            {i}
          </button>
        </li>
      );
    }
    return pageNumbers;
  };
  const getAcceptedPageNumbers = () => {
    const pageNumbers = [];
    for (let i = 1; i <= totalAcceptedPages; i++) {
      pageNumbers.push(
        <li key={i} className={acceptedCurrentPage === i ? 'active' : ''}>
          <button
            rel="customerList"
            className={`px-4 py-2 rounded-md hover:bg-gray-50`}
            style={{
              backgroundColor: currentPage === i ? 'blue' : '',
              color: currentPage === i ? 'white' : 'black'
            }}
            onClick={() => handleAcceptedPageClick(i)}
          >
            {i}
          </button>
        </li>
      );
    }
    return pageNumbers;
  };

  const partnerBank_Api_Call = async () => {
    const partnerBankPayload = {
      id: 0
    }
    const partnerBankResponse = await dispatch(getPartnerBank(partnerBankPayload, loginData?.token_chr))
    if (partnerBankResponse) {
      // console.log(partnerBankResponse)
      setPartnerBank(partnerBankResponse)
    }

  }
  const program_Api_Call = async () => {
    const partnerBankPayload = {
      id: 0
    }
    const programResponse = await dispatch(getPartnerData(partnerBankPayload, loginData?.token_chr))
    if (programResponse) {
      // console.log(programResponse.result)
      // Extracting the 'result' array
      const programArray = programResponse.result || [];
      // const filteredPrograms = programArray.filter(item => !["VTap Muthoot", "VTap V2P", "V2P – I2I", "Avysh", "LC_BD"].includes(item.name));

      // Mapping data to options
      const mappedPrograms = programArray.map(item => ({
        value: item.id,
        label: item.name,
      }));
      setProgram(mappedPrograms);

    }

  }
  const v2pRM_API_CALL = async () => {
    const v2pRmResponse = await dispatch(v2pRMApi(loginData?.token_chr))
    if (v2pRmResponse) {
      // console.log(v2pRmResponse)
      setV2pRm(v2pRmResponse?.result)
      dispatch(setV2PRMData(v2pRmResponse?.result))

    }

  }
  const mailSentCall = async (pageNumber, size) => {
    const mailSentPayload = {
      "filter": `${filterCustomerName !== '' ? `customerName@=${filterCustomerName},` : ''}${filterCustomerEmail !== '' ? `email@=${filterCustomerEmail},` : ''}${filterCustomerPhone !== '' ? `phone@=${filterCustomerPhone}` : ''}`.replace(/,\s*$/, ''),
      "orderBy": "-Id",
      "pageSize": size,
      "pageNumber": pageNumber
    }
    const mailSentResponse = await dispatch(MailSentApi(mailSentPayload, loginData?.token_chr))
    if (mailSentResponse) {
      dispatch(setMailSentData(mailSentResponse))
      dispatch(setFiltersData(mailSentPayload))
      setDisplayedData(mailSentResponse.result.value);
      setTotalPages(mailSentResponse.result.pagedInfo.totalPages);
      localStorage.setItem('mailSentRecordsValue', mailSentResponse?.result.pagedInfo.totalRecords);
    }

  }

  const dispatch = useDispatch();
  const PendingAPICall = async (pageNumber, size) => {
    const pendingDataPayload = {
      "filter": `${filterCustomerName !== '' ? `customerName@=${filterCustomerName},` : ''}${filterCustomerEmail !== '' ? `email@=${filterCustomerEmail},` : ''}${filterCustomerPhone !== '' ? `phone@=${filterCustomerPhone}` : ''}`.replace(/,\s*$/, ''),
      "orderBy": "-Id",
      "pageSize": size,
      "pageNumber": pageNumber
    }
    const data = await dispatch(PendingDataApi(pendingDataPayload, loginData?.token_chr));
    if (data) {
      setDisplayedData1(data.result.value);
      dispatch(setPendingData(data))
      dispatch(setFiltersData(pendingDataPayload))
      localStorage.setItem('pendingRecordsValue', data?.result.pagedInfo.totalPages);
    } else {
      // Handle API error
      // console.error(data.statusText);
    }
  }
  const AcceptedAPICall = async (pageNumber, size) => {
    const acceptedDataPayload = {
      "filter": `${filterCustomerName !== '' ? `customerName@=${filterCustomerName},` : ''}${filterCustomerEmail !== '' ? `email@=${filterCustomerEmail},` : ''}${filterCustomerPhone !== '' ? `phone@=${filterCustomerPhone}` : ''}`.replace(/,\s*$/, ''),
      "orderBy": "-Id",
      "pageSize": size,
      "pageNumber": pageNumber
    }
    const data = await dispatch(AcceptedDataApi(acceptedDataPayload, loginData?.token_chr));
    if (data) {
      setDisplayedData2(data.result.value);
      dispatch(setAcceptedData(data))
      dispatch(setFiltersData(acceptedDataPayload))
      localStorage.setItem('acceptedRecordsValue', data?.result.pagedInfo.totalRecords);
      //navigate('/accepted');
    }
  }
  const ApplyFilter = async (event) => {
    const totalRecords = localStorage.getItem('mailSentRecordsValue');
    event.preventDefault();
    if (filterCustomerEmail.length > 0) {
      if (!emailRegex.test(filterCustomerEmail)) {
        showNotification('Please enter a valid email', 'error')
        return;
      }
    }
    if (filterCustomerPhone.length > 0) {
      if (filterCustomerPhone.length !== 10) {
        showNotification('Phone number must be of atleast 10 digits', 'error')
        return;
      }
    }
    mailSentCall(currentPage, pageSize);

  }
  const ClearFilter = async (event) => {
    const totalRecords = localStorage.getItem('mailSentRecordsValue');
    //event.preventDefault();
    setFilterCustomerName('')
    setFilterCustomerPhone('')
    setFilterCustomerEmail('')
    setCurrentPage(1)
    setPendingCurrentPage(1)
    setAcceptedCurrentPage(1)
    mailSentCallClearFilter(1, pageSize);
  }
  const ApplyPendingFilter = async (event) => {
    const totalRecords = localStorage.getItem('pendingRecordsValue');
    event.preventDefault();
    if (filterCustomerEmail.length > 0) {
      if (!emailRegex.test(filterCustomerEmail)) {
        showNotification('Please enter a valid email', 'error')
        return;
      }
    }
    if (filterCustomerPhone.length > 0) {
      if (filterCustomerPhone.length !== 10) {
        showNotification('Phone number must be of atleast 10 digits', 'error')
        return;
      }
    }
    PendingAPICall(pendingCurrentPage, pendingPageSize);
  }
  const ClearPendingFilter = async (event) => {
    const totalRecords = localStorage.getItem('pendingRecordsValue');
    //event.preventDefault();
    setFilterCustomerName('')
    setFilterCustomerPhone('')
    setFilterCustomerEmail('')
    setCurrentPage(1)
    setPendingCurrentPage(1)
    setAcceptedCurrentPage(1)
    pendingAPICallClearFilter(1, pendingPageSize);
  }
  const pendingAPICallClearFilter = async (pageNumber, size) => {
    const pendingPayload = {
      "filter": '',
      "orderBy": "-Id",
      "pageSize": size,
      "pageNumber": pageNumber
    }
    const pendingResp = await dispatch(PendingDataApi(pendingPayload, loginData?.token_chr))
    if (pendingResp) {
      dispatch(setPendingData(pendingResp))
      setDisplayedData1(pendingResp?.result.value);
      dispatch(setFiltersData(pendingPayload))
      setTotalPendingPages(pendingResp?.result.pagedInfo.totalPages);
      localStorage.setItem('pendingRecordsValue', pendingResp?.result.pagedInfo.totalRecords);
    }

  }
  const ApplyAcceptedFilter = async (event) => {
    const totalRecords = localStorage.getItem('acceptedRecordsValue');
    event.preventDefault();
    if (filterCustomerEmail.length > 0) {
      if (!emailRegex.test(filterCustomerEmail)) {
        showNotification('Please enter a valid email', 'error')
        return;
      }
    }
    if (filterCustomerPhone.length > 0) {
      if (filterCustomerPhone.length !== 10) {
        showNotification('Phone number must be of atleast 10 digits', 'error')
        return;
      }
    }
    AcceptedAPICall(acceptedCurrentPage, acceptedPageSize);
  }
  const ClearAcceptedFilter = async (event) => {
    const totalRecords = localStorage.getItem('acceptedRecordsValue');
    //event.preventDefault();
    setFilterCustomerName('')
    setFilterCustomerPhone('')
    setFilterCustomerEmail('')
    setCurrentPage(1)
    setPendingCurrentPage(1)
    setAcceptedCurrentPage(1)
    acceptedAPICallClearFilter(1, acceptedPageSize);
  }
  const acceptedAPICallClearFilter = async (pageNumber, size) => {
    const acceptedPayload = {
      "filter": '',
      "orderBy": "-Id",
      "pageSize": size,
      "pageNumber": pageNumber
    }
    const acceptedResp = await dispatch(AcceptedDataApi(acceptedPayload, loginData?.token_chr))
    if (acceptedResp) {
      dispatch(setAcceptedData(acceptedResp))
      setDisplayedData2(acceptedResp.result.value);
      dispatch(setFiltersData(acceptedPayload))
      setTotalAcceptedPages(acceptedResp.result.pagedInfo.totalPages);
      localStorage.setItem('acceptedRecordsValue', acceptedResp.result.pagedInfo.totalRecords);
    }

  }
  const mailSentCallClearFilter = async (pageNumber, size) => {
    const mailSentPayload = {
      "filter": '',
      "orderBy": "-Id",
      "pageSize": size,
      "pageNumber": pageNumber
    }
    const mailSentResponse = await dispatch(MailSentApi(mailSentPayload, loginData?.token_chr))
    if (mailSentResponse) {
      dispatch(setMailSentData(mailSentResponse))
      dispatch(setFiltersData(mailSentPayload))

      setDisplayedData(mailSentResponse.result.value);
      setTotalPages(mailSentResponse.result.pagedInfo.totalPages);
      localStorage.setItem('mailSentRecordsValue', mailSentResponse.result.pagedInfo.totalRecords);
    }

  }
  const ExportData = async (event) => {
    event.preventDefault();
    let type = '';
    if (event.target.name === 'mail-sent') {
      type = 'mail-sent';
    } else if (event.target.name === 'pending') {
      type = 'pending';
    } else {
      type = 'accepted'
    }
    const filterPayload = {
      "filter": savedfilterData?.filter,
      "orderBy": '',
      "type": type
    }
    // console.log(filterPayload)
    const data = await dispatch(ExportDataApi(filterPayload, loginData?.token_chr));
    if (data) {
      // console.log(data)
      // Decode base64 string to binary data
      const binaryData = atob(data.result);

      // Create a Blob from the binary data
      const arrayBuffer = new ArrayBuffer(binaryData.length);
      const uint8Array = new Uint8Array(arrayBuffer);
      for (let i = 0; i < binaryData.length; i++) {
        uint8Array[i] = binaryData.charCodeAt(i);
      }

      const blob = new Blob([uint8Array], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

      // Generate a random filename
      const randomFileName = `excel_file_${Date.now()}.xlsx`;

      // Create a download link
      const downloadLink = document.createElement('a');
      downloadLink.href = URL.createObjectURL(blob);
      downloadLink.download = randomFileName;

      // Trigger a click event on the link to initiate the download
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);

      // dispatch(setMailSentData(data))
    }
  }
  const ResendEmail = async (id) => {
    // console.log(userAgent)
    const resendEmailPayload = {
      "customerId": id,
      "createdAt": new Date(),
      "createdBy": loginData?.userId,
      "createdIp": "",
      "createdUserAgent": userAgent
    }
    // console.log(resendEmailPayload)
    const data = await dispatch(ResendEmailApi(resendEmailPayload, loginData?.token_chr));
    if (data.statusCode === 200) {
      showNotification('Welcome email resent successfully', 'success')
    }
  }
  const UpdateV2PRM = async (customerId, newID) => {
    // console.log(userAgent)
    const updateV2PRMPayload = {
      "customerId": customerId,
      "v2PRM": parseInt(newID)
    }
    // console.log(updateV2PRMPayload)
    const data = await dispatch(UpdateV2PRMApi(updateV2PRMPayload, loginData?.token_chr));
    mailSentCall(currentPage, pageSize);
    if (data.statusCode === 200) {
      showNotification('V2P RM Updated Successfully', 'success')
      v2pRM_API_CALL();
    }
  }
  const UpdateHDFCRM = async () => {
    // console.log(userAgent)
    const Payload = {
      "customerId": customerId,
      "hdfcrm": hdfcRM
    }
    // console.log({ Payload })
    const data = await dispatch(UpdateHDFCRMApi(Payload, loginData?.token_chr));
    mailSentCall(currentPage, pageSize);
    AcceptedAPICall(currentPage, pageSize);
    PendingAPICall(currentPage, pageSize);
    if (data?.statusCode === 200) {
      setIsRMModalOpen(false)
      showNotification('HDFC RM Updated Successfully', 'success')
      v2pRM_API_CALL();
    }
  }
  const UpdatePhoneEmail = async (event) => {
    event.preventDefault();
    // console.log(userAgent)
    const Payload = {
      "customerId": customerId,
      "phone": changePhone,
      "email": changeEmail,
      "modifiedBy": loginData?.userId,
      "modifiedIp": "",
      "modifiedUserAgent": userAgent
    }
    // console.log(Payload)
    const data = await dispatch(UpdatePhoneEmailApi(Payload, loginData?.token_chr));
    mailSentCall(currentPage, pageSize);
    setIsProfileModalOpen(false);
    if (data.statusCode === 200) {
      showNotification('Customer Updated Successfully', 'success')
    }
  }
  const OnBoardNewCustomer = async (event) => {
    event.preventDefault();
    let selectedBank;
    if (selectedBankID !== null) {
      selectedBank = partnerBank?.result.find(data => data?.id === parseInt(selectedBankID === null ? '' : selectedBankID))
    }
    const selectedHDFCRM = v2pRM?.find(data => data?.id === selectedValueID);
    const programsData = selectedPrograms?.map((option) => ({
      programId: option.value,
      program: option.label,
    }));
    // console.log(selectedHDFCRM)
    const payload = {
      "customerName": OBCustomerName,
      "email": OBCustomerEmail,
      "phone": OBCustomerPhone,
      "partnerBankId": selectedBank?.id,
      "partnerBankName": selectedBank?.name,
      "createdBy": loginData?.userId,
      "createdIp": "",
      "createdUserAgent": userAgent,
      "hdfcrm": OBCustomerHDFCRM,
      "v2PRM": selectedHDFCRM.id,
      "programs": programsData
    }
    console.log(payload)

    if (OBCustomerName === '') {
      showNotification('Please enter customer name', 'error')
    } else if (OBCustomerEmail === '') {
      showNotification('Please enter customer email', 'error')
    } else if (!emailRegex.test(OBCustomerEmail)) {
      showNotification('Please enter a valid email', 'error')
    }
    else if (OBCustomerPhone === '') {
      showNotification('Please enter customer phone', 'error')
    } else if (OBCustomerPhone.length !== 10) {
      showNotification('Phone number must be of atleast 10 digits', 'error')
    }
    else if (selectedBank === undefined || selectedBank.length <= 0) {
      showNotification('Please enter partner bank', 'error')
    }
    else if (selectedPrograms === undefined || selectedPrograms.length <= 0) {
      showNotification('Please enter program/programs', 'error')
    }
    //  else if (OBCustomerPhone.length !== 10) {
    //   showNotification('Phone number must be of 10 digits ', 'warning')
    // }
    else {
      const data = await dispatch(CreateCustomerApi(payload, loginData?.token_chr));
      // console.log(data)
      if (data?.statusCode === 200) {
        showNotification('Customer Added Successfully', 'success')
        mailSentCall(currentPage, pageSize);
        setIsModalOpen(false)
        setOBCustomerEmail('')
        setOBCustomerName('')
        setOBCustomerHDFCRM('')
        setOBCustomerPhone('')
        setSelectedBank(null)
        setSelectedPrograms(null)
      }

    }
  }
  // Custom styles for react-select
  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      padding: "2px",
      marginTop: "8px",
      borderRadius: "6px"
    }),
  };

  function logout() {
    dispatch(Authenticate(false));
    dispatch(LoginUser(''))
    navigate('/')
  }

  const [activeTab, setActiveTab] = useState(1);

  const handleTabClick = (tabNumber) => {
    setActiveTab(tabNumber);
    if (tabNumber === 2) {
      ClearPendingFilter();
      //PendingAPICall(pendingCurrentPage, pendingPageSize);
    } else if (tabNumber === 3) {
      ClearAcceptedFilter();
      //AcceptedAPICall(acceptedCurrentPage, acceptedPageSize);
    } else {
      ClearFilter();
      //mailSentCall(currentPage, pageSize);
    }
    // You can add logic to navigate to the corresponding page here
  };
  const ViewDetails = (items, type) => {
    console.log(type)
    // Convert the items object to a query string
    navigate('/details', { state: { item: items, type: type !== '' ? type : '' } });
  }
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isProfileModalOpen, setIsProfileModalOpen] = useState(false);
  const [isRMModalOpen, setIsRMModalOpen] = useState(false);
  useEffect(() => {
    // Add a class to the body when the modal is open
    if (isModalOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      // Remove the class when the modal is closed
      document.body.style.overflow = 'auto';
    }

    // Clean up the effect on component unmount
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isModalOpen]); // Run the effect whenever isModalOpen changes

  function formatDate(dateString) {
    const date = new Date(dateString);
    if (dateString.includes("0001") || dateString === null) {
      return '-'
    }

    // Array of month names
    const months = [
      "Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];

    // Get the month, day, year, hours, and minutes
    const month = months[date.getMonth()];
    const day = date.getDate();
    const year = date.getFullYear();
    const hours = date.getHours() % 12 || 12;
    const minutes = date.getMinutes();
    const period = date.getHours() < 12 ? "AM" : "PM";

    // Construct the formatted date string
    const formattedDate = `${day}-${month}-${year}`;

    return formattedDate;
  }
  const cancelOnboarding = () => {
    setIsModalOpen(false)
    setOBCustomerEmail('')
    setOBCustomerName('')
    setOBCustomerHDFCRM('')
    setOBCustomerPhone('')
    setSelectedBank(null)
    setSelectedPrograms(null)
  }
  return (
    <>
      <div className='mailsentbody'>
        <LogoDiv className='logoBG' >
          <div className="rightElement">
            <DashboardHeader />
            <div className="grid mt-6 grid-cols-12 gap-4">
              <div className="col-span-12 md:col-span-1 lg:col-span-1"></div>
              <div className="col-span-12 md:col-span-10 lg:col-span-10 ">
                <div className="flex items-center justify-between mt-2 p-2 mx-4">
                  <div className="col-span-6">
                    <h1 className="text-3xl ">Customer List</h1>
                  </div>
                  <div className="col-span-6 text-right">
                    <button className="px-4 py-2 border border-sky-700 text-sky-700 rounded hover:bg-sky-700 hover:text-white" data-toggle="modal"
                      data-target="#myModal" onClick={() => setIsModalOpen(true)}
                    >
                      Onboard new customer
                    </button>
                  </div>

                </div>
                <div style={{display:'flex',justifyContent:'right',padding:'5px'}}>
  <img src={logo} width={"100px"} height={"100px"}/>
</div>
                <div className='bg-white mx-2 shadow-md p-6 mt-4 rounded-lg'>
                  <div className="flex">
                    <div
                      onClick={() => handleTabClick(1)}
                      className={`cursor-pointer text-center w-full px-4 py-2 border-b ${activeTab === 1 ? 'border-sky-700 text-black font-bold text-lg' : 'text-black font-bold text-lg hover:border-sky-700'
                        }`}
                    >
                      MAIL SENT
                    </div>
                    <div
                      onClick={() => handleTabClick(2)}
                      className={`cursor-pointer text-center w-full px-4 py-2 border-b ${activeTab === 2 ? 'border-sky-700 text-black font-bold text-lg' : 'text-black font-bold text-lg hover:border-sky-700'
                        }`}
                    >
                      PENDING FOR REVIEW
                    </div>
                    <div
                      onClick={() => handleTabClick(3)}
                      className={`cursor-pointer text-center w-full px-4 py-2 border-b ${activeTab === 3 ? 'border-sky-700 text-black font-bold text-lg' : 'text-black font-bold text-lg hover:border-sky-700'
                        }`}
                    >
                      ACCEPTED
                    </div>
                  </div>

                  {/* Render content based on the active tab */}
                  <div className='p-2'>
                    {activeTab === 1 && <>

                      {/* <button onClick={refreshToken}>refresh token</button> */}



                      <StaffFilters
                        ClearFilter={ClearFilter}
                        ApplyFilter={ApplyFilter}
                        handleChangeNameFilter={handleChangeNameFilter}
                        handleChangeEmailFilter={handleChangeEmailFilter}
                        handleChangePhoneFilter={handleChangePhoneFilter}
                        filterCustomerName={filterCustomerName}
                        filterCustomerEmail={filterCustomerEmail}
                        filterCustomerPhone={filterCustomerPhone}
                        ExportData={ExportData}
                        ExportType="mail-sent" />

                      <StaffGrid
                        displayedData={displayedData}
                        getStartingSerialNumber={getStartingSerialNumber}
                        ResendEmail={ResendEmail}
                        formatDate={formatDate}
                        openEditModal={openEditModal}
                        ViewDetails={ViewDetails}
                        openEditV2PRMModal={openEditV2PRMModal}
                        GridType="mail-sent" />

                      <StaffPagination
                        currentPage={currentPage}
                        handlePageClick={handlePageClick}
                        handleNextClick={handleNextClick}
                        getPageNumbers={getPageNumbers}
                        totalPages={totalPages}
                        Data={mailSentData}
                        ButtonKey="mailSentPage" />




                    </>}
                    {activeTab === 2 && <>
                      <StaffFilters
                        ClearFilter={ClearPendingFilter}
                        ApplyFilter={ApplyPendingFilter}
                        handleChangeNameFilter={handleChangeNameFilter}
                        handleChangeEmailFilter={handleChangeEmailFilter}
                        handleChangePhoneFilter={handleChangePhoneFilter}
                        filterCustomerName={filterCustomerName}
                        filterCustomerEmail={filterCustomerEmail}
                        filterCustomerPhone={filterCustomerPhone}
                        ExportData={ExportData}
                        ExportType="pending" />

                      <StaffGrid
                        displayedData={displayedData1}
                        getStartingSerialNumber={getStartingSerialNumber}
                        ResendEmail={ResendEmail}
                        formatDate={formatDate}
                        openEditModal={openEditModal}
                        ViewDetails={ViewDetails}
                        openEditV2PRMModal={openEditV2PRMModal}
                        GridType="pending" />

                      <StaffPagination
                        currentPage={pendingCurrentPage}
                        handlePageClick={handlePendingPageClick}
                        handleNextClick={handlePendingNextClick}
                        getPageNumbers={getPendingPageNumbers}
                        totalPages={totalPendingPages}
                        Data={pendingData}
                        ButtonKey="pendingPage" />


                    </>}
                    {activeTab === 3 && <>

                      <StaffFilters
                        ClearFilter={ClearAcceptedFilter}
                        ApplyFilter={ApplyAcceptedFilter}
                        handleChangeNameFilter={handleChangeNameFilter}
                        handleChangeEmailFilter={handleChangeEmailFilter}
                        handleChangePhoneFilter={handleChangePhoneFilter}
                        filterCustomerName={filterCustomerName}
                        filterCustomerEmail={filterCustomerEmail}
                        filterCustomerPhone={filterCustomerPhone}
                        ExportData={ExportData}
                        ExportType="accepted" />



                      <StaffGrid
                        displayedData={displayedData2}
                        getStartingSerialNumber={getStartingSerialNumber}
                        ResendEmail={ResendEmail}
                        formatDate={formatDate}
                        openEditModal={openEditModal}
                        ViewDetails={ViewDetails}
                        openEditV2PRMModal={openEditV2PRMModal}
                        GridType="accepted" />


                      <StaffPagination
                        currentPage={acceptedCurrentPage}
                        handlePageClick={handleAcceptedPageClick}
                        handleNextClick={handlePendingNextClick}
                        getPageNumbers={getAcceptedPageNumbers}
                        totalPages={totalAcceptedPages}
                        Data={acceptedData}
                        ButtonKey="acceptedPage"
                      />


                    </>}
                  </div>
                </div>
                <div className="col-span-12 md:col-span-1 lg:col-span-1"></div>
              </div>
              <Transition
                as={Fragment}
                show={isModalOpen}
                enter="ease-out duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity">
                  <div className="fixed inset-0 z-10 overflow-y-auto">
                    <div className="flex items-center justify-center min-h-full p-4 sm:p-0">
                      <Transition
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        enterTo="opacity-100 translate-y-0 sm:scale-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                        leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                      >
                        <div className="relative transform overflow-hidden rounded-lg text-left transition-all w-full max-w-2xl sm:max-w-3xl h-auto">
                          <form onSubmit={OnBoardNewCustomer}
                          >
                            <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                              <div className="sm:flex sm:items-start">
                                <div className=" w-full sm:text-left">
                                  <h3 className="text-xl text-center pb-3 font-semibold leading-6 text-gray-900" id="modal-title">Customer Onboarding</h3>
                                  <div className="mt-2 border-t">
                                    <div className="grid mt-4 grid-cols-12 gap-2">
                                      <div className='col-span-12'>
                                        <label>Customer Name <span style={{ color: "red", fontWeight: 'bold' }}>*</span></label>
                                        <OnboardingCustomerInput value={OBCustomerName}
                                          onChange={handleChangeOBCustomerName} inputStyles={{ padding: "8px" }} />
                                      </div>
                                      <div className='col-span-12 sm:col-span-12 md:col-span-6'>
                                        <label>Email <span style={{ color: "red", fontWeight: 'bold' }}>*</span></label>
                                        <OnboardingEmailInput value={OBCustomerEmail}
                                          onChange={handleOBCustomerEmail} inputStyles={{ padding: "8px" }} />
                                      </div>
                                      <div className='col-span-12 sm:col-span-12 md:col-span-6'>
                                        <label>Phone <span style={{ color: "red", fontWeight: 'bold' }}>*</span> </label>
                                        <OnboardingPhoneInput value={OBCustomerPhone}
                                          onChange={handleOBCustomerPhone} inputStyles={{ padding: "8px" }} />
                                      </div>
                                      <div className='col-span-12 sm:col-span-12 md:col-span-6'>
                                        <label>Partner Bank <span style={{ color: "red", fontWeight: 'bold' }}>*</span> </label>
                                        {/* <select
                                          name="pb"
                                          value={selectedBank}
                                          onChange={handleChangeBank}
                                          className="block w-full p-2 mt-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring focus:border-indigo-300"
                                        >
                                          {partnerBank?.result.map((bank) => (
                                            <option key={bank.id} data-id={bank.id} value={bank.name}>
                                              {bank.name}
                                            </option>
                                          ))}
                                        </select> */}
                                        <Select
                                          name="pb"
                                          styles={customStyles}
                                          menuPortalTarget={document.body}
                                          value={selectedBank}
                                          menuPlacement='top'
                                          onChange={handleChangeBank}
                                          options={partnerBank?.result.map(bank => ({ value: bank.id, label: bank.name }))}
                                        />
                                      </div>
                                      <div className='col-span-12 sm:col-span-12 md:col-span-6'>
                                        <label>Program <span style={{ color: "red", fontWeight: 'bold' }}>*</span> </label>
                                        <Select
                                          isMulti
                                          styles={customStyles}
                                          menuPortalTarget={document.body}
                                          menuPlacement='top'
                                          name="ct"
                                          options={program}
                                          value={selectedPrograms}
                                          onChange={handleChangeProgram}
                                        />
                                      </div>
                                      <div className='col-span-12 sm:col-span-12 md:col-span-6'>
                                        <label>V2P RM <span style={{ color: "red", fontWeight: 'bold' }}>*</span> </label>
                                        <select
                                          className="block w-full p-2 mt-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring focus:border-indigo-300"
                                          name="eV2pRm" id="eV2pRm" value={selectedValue} onChange={handleChange}>
                                          {v2pRM?.map((item) => (
                                            <option key={item.id} value={item.email}>
                                              {item.email}
                                            </option>
                                          ))}
                                        </select>
                                      </div>
                                      <div className='col-span-12 sm:col-span-12 md:col-span-6'>
                                        <label>HDFC RM  </label>
                                        <OnboardingHDFCRMInput value={OBCustomerHDFCRM}
                                          onChange={handleOBCustomerHDFCRM} inputStyles={{ padding: "8px" }} />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                              <button type="submit" className="inline-flex w-full justify-center rounded-md bg-sky-700 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-sky-700 sm:ml-3 sm:w-auto">Proceed</button>
                              <button type="button" className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto" onClick={cancelOnboarding}>Cancel</button>
                            </div>
                          </form>
                        </div>
                      </Transition>
                    </div>
                  </div>
                </div>
              </Transition>

              <Transition
                as={Fragment}
                show={isProfileModalOpen}
                enter="ease-out duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity flex items-center justify-center">
                  <div className="bg-white rounded-lg w-full max-w-md max-w-lg">
                    <div className="flex min-h-full items-end justify-center p-4 sm:items-center sm:p-0">
                      <Transition
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        enterTo="opacity-100 translate-y-0 sm:scale-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                        leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                      >
                        <div className="relative transform overflow-hidden rounded-lg text-left transition-all w-full max-w-md sm:max-w-lg h-auto">
                          <form onSubmit={UpdatePhoneEmail}>
                            <div className="px-4 pb-4  sm:p-6 sm:pb-4">
                              <div className="sm:flex sm:items-start">
                                <div className="mt-3 w-full sm:ml-4 sm:mt-0 sm:text-left">
                                  <h4 className="text-xs font-semibold leading-1 text-gray-500">Change email/phone for</h4>
                                  <h3 className="text-base font-semibold leading-6 text-gray-900" id="modal-title">{customerName}</h3>
                                  <div className="mt-2 border-t">
                                    <div className="grid mt-4 grid-cols-12 gap-4">
                                      <div className="col-span-12 sm:col-span-12 md:col-span-6">
                                        <label>Email <span style={{ color: "red", fontWeight: 'bold' }}>*</span></label>
                                        <OnboardingEmailInput value={changeEmail}
                                          onChange={handleEmailChange} inputStyles={{ padding: "8px" }} />
                                      </div>
                                      <div className="col-span-12 sm:col-span-12 md:col-span-6">
                                        <label>Phone <span style={{ color: "red", fontWeight: 'bold' }}>*</span></label>
                                        <OnboardingPhoneInput value={changePhone}
                                          onChange={handlePhoneChange} inputStyles={{ padding: "8px" }} />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                              <button type="submit" className="inline-flex w-full justify-center rounded-md bg-sky-700 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-sky-700 sm:ml-3 sm:w-auto">Proceed</button>
                              <button type="button" className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto" onClick={() => setIsProfileModalOpen(false)}>Cancel</button>
                            </div>
                          </form>

                        </div>
                      </Transition>
                    </div>
                  </div>
                </div>
              </Transition>
              <Transition
                as={Fragment}
                show={isRMModalOpen}
                enter="ease-out duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity flex items-center justify-center">
                  <div className="bg-white  rounded-lg w-full max-w-md max-w-lg">
                    <div className="flex min-h-full items-end justify-center p-4 sm:items-center sm:p-0">
                      <Transition
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        enterTo="opacity-100 translate-y-0 sm:scale-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                        leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                      >
                        <div className="relative transform overflow-hidden rounded-lg text-left transition-all w-full max-w-md sm:max-w-lg h-auto">
                          <div className="px-4 pb-4  sm:p-6 sm:pb-4">
                            <div className="sm:flex sm:items-start">
                              <div className=" w-full sm:ml-4 sm:mt-0 sm:text-left">
                                <h4 className="text-xs font-semibold leading-1 text-gray-500">Change RM for</h4>
                                <h3 className="text-base font-semibold leading-6 text-gray-900" id="modal-title">{customerName || ""}</h3>
                                <div className="mt-2 border-t">
                                  <div className="grid mt-4 grid-cols-12 gap-4">
                                    <div className="col-span-12 sm:col-span-12 md:col-span-12">
                                      <label>V2P RM <span style={{ color: "red", fontWeight: 'bold' }}>*</span> </label>
                                      <select
                                        className="block w-full p-2 mt-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring focus:border-indigo-300"
                                        name="eV2pRm" id="eV2pRm" value={selectedValue} onChange={handleChangeV2PRM}>
                                        {v2pRM?.map((item) => (
                                          <option key={item.id} value={item.email} data-id={item.id}>
                                            {item.email}
                                          </option>
                                        ))}
                                      </select>
                                    </div>
                                    <div className="col-span-12 sm:col-span-12 md:col-span-12">
                                      <label>HDFC RM <span style={{ color: "red", fontWeight: 'bold' }}>*</span> </label>
                                      <OnboardingHDFCRMInput value={hdfcRM} onChange={handleHDFCRMChange}
                                        inputStyles={{ padding: "8px" }} />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                            <button onClick={UpdateHDFCRM}
                              type="button" className="inline-flex w-full justify-center rounded-md bg-green-500 px-3 py-2 text-sm font-semibold text-white shadow-sm hover bg-green-500 sm:ml-3 sm:w-auto">
                              Save
                            </button>
                            <button type="button" className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto" onClick={() => setIsRMModalOpen(false)}>
                              Cancel
                            </button>
                          </div>
                        </div>
                      </Transition>
                    </div>
                  </div>
                </div>
              </Transition>
            </div>
          </div>
        </LogoDiv>
      </div>
    </>
  );
}

export default MailSent;

